import * as React from 'react';
import { Button } from '../../../ButtonV2/ButtonV2';
import { colorsV2 } from '../../../colors-v2';
import { Box } from '../../../Common/BoxV2';
import { Typography } from '../../../DesignSystemV2/Typography';
import { uniq } from 'lodash';

interface ExerciseInCompleteNoticeProps extends React.HTMLAttributes<HTMLDivElement> {
  onBack: () => void;
  text: string;
  missingFields?: string[];
}

export const ExerciseInCompleteNotice = (props: ExerciseInCompleteNoticeProps) => {
  const { text, onBack, missingFields } = props;
  const fieldsStr = uniq(missingFields).join(', ');
  return (
    <Box
      textAlign="center"
      contentEditable={false}
      border={`1px dashed ${colorsV2.gray40}`}
      bg="gray5"
      borderRadius="16px"
      p="32px"
      mb="32px"
    >
      <Think styled={{ margin: '0 auto' }} />
      <Typography.Paragraph mb="8px" mt="24px" variant="semi-bold/16">
        {`${text} not completed`}
      </Typography.Paragraph>
      <Typography.Paragraph variant="regular/14" mb="24px" color="gray100">
        {`Missing data filled "${fieldsStr}"`}
      </Typography.Paragraph>
      <Button.Primary onClick={() => onBack()}>Kiểm tra nhập liệu</Button.Primary>
    </Box>
  );
};

const Think = (props) => {
  return (
    <svg
      width="102"
      height="127"
      viewBox="0 0 102 127"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M100.552 23.6444C99.4178 20.6022 97.749 17.8425 95.7801 15.2737C91.9741 10.3123 87.2751 5.53801 81.577 2.81142C75.4398 -0.128021 68.5597 -0.373883 61.8992 0.330701C49.3832 1.6518 36.5306 5.15269 26.408 12.9361C17.0137 20.1581 10.1226 31.4755 10.28 43.6039C10.2983 45.0938 10.452 47.4828 10.6716 48.9543C10.7923 49.7727 11.6963 50.6094 12.4282 50.6607C19.8463 51.1488 30.9533 50.3305 33.182 50.3305C35.4107 50.3305 36.1939 48.6497 36.805 46.2204C37.698 42.6644 39.2533 39.3801 41.4637 36.6278C41.2368 36.6425 41.01 36.6608 40.7794 36.6755C40.3 36.7048 38.3128 37.1012 38.1042 36.7305C37.8187 36.2204 39.8169 34.1691 40.106 33.8315C41.2003 32.5581 42.3055 31.3324 43.5132 30.1617C44.7611 28.9507 45.9358 27.7471 47.1289 26.5324C48.7757 24.8554 50.5653 23.2664 52.2999 21.6627C52.4646 21.5122 52.633 21.3618 52.805 21.2113C51.8132 20.9948 50.8654 20.5581 50.02 19.7288C49.7199 19.4352 49.9578 18.9545 50.3494 18.9361C53.6467 18.7783 56.1389 16.1618 59.224 15.2884C61.7455 14.5728 66.0089 15.2591 66.6933 18.2536C66.7006 18.2756 66.7079 18.3013 66.7152 18.3269C68.8012 18.6352 69.8333 20.4407 70.6677 22.1324C71.4618 23.7398 71.7436 25.5086 71.868 27.2884C73.3136 27.1232 74.7591 27.3434 75.7399 28.3819C77.4746 30.2205 76.1571 32.9581 74.2687 34.136C74.7994 35.1122 75.2569 36.1287 75.6265 37.1782C76.7024 40.2314 77.1452 43.4461 76.9147 46.6754C76.6036 51.0167 74.148 55.2259 71.6228 59.2956C71.6594 60.2791 71.6851 61.2515 71.6997 62.202C71.707 62.624 71.707 63.046 71.7107 63.4717C72.9293 64.3598 75.4325 66.4955 76.5341 67.4093C79.9339 70.2276 82.7042 73.4276 85.8259 76.4918C86.7188 74.712 87.7582 73.0093 88.8195 71.4166C92.4937 65.8974 96.695 60.7414 98.8652 54.3782C100.003 51.0424 100.596 47.5635 101.043 44.0773C101.482 40.6498 101.873 37.1746 101.98 33.7177C102.093 30.3085 101.753 26.859 100.552 23.6444Z"
        fill="#F4F4F5"
      />
      <path
        d="M69.5566 40.5162C69.5749 38.5601 69.5859 36.7325 69.5786 35.2756C70.8302 35.1765 72.0086 34.9453 73.2455 34.604C75.6096 33.9508 77.7871 30.5451 75.745 28.3835C74.1165 26.6587 71.2108 27.1908 69.1395 27.9909C69.0223 27.0514 68.8723 26.1229 68.6893 25.2238C68.1623 22.6402 67.3353 19.5648 64.8614 18.174C60.6711 15.8179 55.4781 18.7318 52.3016 21.664C50.5669 23.2677 48.7774 24.8568 47.1306 26.5339C45.9412 27.7487 44.7628 28.9524 43.5149 30.1634C42.3072 31.3341 41.2057 32.5599 40.1078 33.8333C39.8187 34.1709 37.8205 36.2224 38.106 36.7325C38.3145 37.0995 40.3017 36.7068 40.7811 36.6775C41.7839 36.6151 42.7683 36.5307 43.7637 36.472C44.5322 36.4242 46.6548 36.472 46.6548 36.472C46.6548 36.472 46.545 38.2298 46.5487 39.1583C46.567 44.7622 46.9622 50.3661 46.9622 56.0031"
        stroke="#242938"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M71.3906 31.5063C71.7383 31.4402 72.0969 31.3705 72.4226 31.3008"
        stroke="#242938"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M58.75 30.8486V29.3477"
        stroke="#242938"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M54.1992 30.8486V29.3477"
        stroke="#242938"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M55.3438 37.1576C56.0684 36.6144 57.9165 35.5759 58.6411 36.5374"
        stroke="#242938"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M71.6484 63.4258C72.8415 64.2845 75.4178 66.4828 76.5413 67.4149C80.0729 70.3435 82.9237 73.6831 86.1954 76.8539C90.038 80.5751 93.3755 85.1148 96.4825 89.4709"
        stroke="#242938"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M44.1289 61.2656C45.4171 62.6345 46.9651 63.563 48.5387 63.563"
        stroke="#242938"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M71.7264 75.6368C71.7264 75.6368 71.6899 72.499 71.7008 70.7632C71.7191 67.9117 71.7447 65.0455 71.7045 62.2013C71.6276 56.3773 71.0567 49.7458 70.4383 44.0061C70.3248 42.9308 69.5746 37.7379 66.7787 38.7618C65.3697 39.2793 65.6808 42.7657 65.6808 44.0061C65.6808 45.9511 65.6844 48.5971 65.6844 50.3733C65.6844 52.1532 65.4648 54.1203 65.4648 54.1203"
        stroke="#242938"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M65.7941 54.4721C65.7941 54.4721 64.2388 53.3601 63.2836 52.9968C61.699 52.3986 60.4657 51.7747 58.8189 51.5362C57.8344 51.3931 56.4328 51.316 55.474 51.7307C54.7787 52.028 53.6698 53.3161 53.7723 53.929"
        stroke="#242938"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M61.297 57.14C61.297 57.14 59.2988 55.8702 58.2119 55.4115C57.0774 54.9307 55.4123 54.0096 54.1863 54.1417C52.1919 54.3583 49.7472 56.9785 49.6484 59.052"
        stroke="#242938"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M57.5807 60.4395C57.5807 60.4395 55.9485 59.2541 54.9055 58.9826C53.9247 58.7293 52.9073 58.4064 51.8753 58.4688C50.4261 58.5605 49.3978 59.3569 48.8781 60.7551C48.3109 62.2891 48.084 68.6967 51.191 67.9811C52.7134 67.6288 52.1205 64.7589 51.7436 63.7497C52.4901 64.9388 53.9174 65.5773 55.2824 65.0819C51.6594 65.1186 54.0125 74.2272 57.7856 73.7685"
        stroke="#242938"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1 99.8117C1.12809 97.3786 1.73556 95.7785 2.78953 93.6133C3.81788 91.4994 6.78948 87.925 8.5278 86.4313C10.2698 84.934 13.0108 83.5028 15.9824 82.9707C17.9842 80.0788 23.3639 75.1465 27.082 72.5519C30.8002 69.9609 35.3637 66.7131 42.1487 62.5808C42.7269 62.2285 44.1285 61.267 44.1285 61.267C44.1285 61.267 44.7762 59.4394 45.2154 58.5953C45.6728 57.7146 46.0095 56.9769 46.6756 56.0117C48.1943 56.1548 50.7304 56.4044 50.7304 56.4044"
        stroke="#242938"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M57.1714 74.1836C56.9665 76.2938 57.0762 80.0737 57.0762 80.0737"
        stroke="#242938"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M63.7972 80.0767C61.5026 80.5428 58.509 80.8584 56.3828 80.0767C56.3828 82.2236 56.5694 85.3356 56.6756 87.6036C56.7817 89.8239 56.5658 93.8131 57.0415 94.2425C57.5173 94.6718 59.1422 94.7159 60.3352 94.6388C63.3653 94.4443 66.3845 93.2002 69.0048 91.8754C69.8502 91.446 70.5894 91.1047 71.3872 90.6166C71.7824 90.3744 72.6571 89.6808 72.9389 89.2991C73.3305 88.767 73.2426 87.1926 73.2426 86.4807C73.2426 85.0017 73.0633 80.9942 72.895 79.5336C72.6315 77.2362 72.6242 75.2031 71.8813 75.2031C71.0322 77.339 66.5053 79.5262 63.7972 80.0767Z"
        stroke="#242938"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M54.1831 71.3945C53.7952 72.8111 46.9554 82.6721 50.1173 83.1748C50.6114 83.2519 51.5556 82.3638 52.0277 82.661C52.895 83.2078 51.5007 85.4905 51.2701 85.9639C50.6882 87.1493 48.7303 90.4852 51.3067 89.0943C51.8117 90.1292 50.3186 93.1973 49.4184 93.9936"
        stroke="#242938"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M29.0835 90.0938C29.2482 90.9452 28.9262 92.281 28.3553 92.8939C27.444 93.8774 25.9253 94.2077 23.6234 94.2334C27.1769 94.4829 26.2473 96.6995 24.7981 98.3106C23.3489 99.9217 19.832 99.8813 19.832 99.0813C19.832 97.4555 23.0781 96.6041 24.714 96.5417C25.918 96.4977 29.6288 95.8114 28.5822 98.8244C30.9024 96.6335 32.5382 95.8114 35.2243 95.0224C37.9105 94.2334 39.6378 95.4481 39.9599 97.9583C41.1785 96.3399 42.2069 95.4298 44.0477 94.5123C45.4749 93.8003 47.3596 93.7563 48.871 93.9875C50.9094 94.2994 53.2223 95.0518 55.107 95.8004"
        stroke="#242938"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M57.0486 94.2422C56.1593 94.734 55.3396 95.534 54.6589 96.301C53.8831 97.1781 53.4183 98.8185 52.8437 99.8938C51.6251 102.191 50.659 105.215 50.5784 107.824C50.5309 109.406 51.2299 110.412 51.8154 111.825C52.3387 113.083 52.1704 112.97 51.508 113.938C50.5235 115.373 50.3955 117.388 50.0625 119.04C49.8099 120.306 49.6013 121.553 49.8758 122.838C50.0332 123.576 50.465 124.229 50.3735 125.003C50.3589 124.805 50.443 124.698 50.4796 124.508"
        stroke="#242938"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M72.9453 89.2969C74.486 92.7502 74.6653 97.9101 75.024 101.877C75.3314 105.279 75.679 108.725 75.8218 112.138C75.8657 113.155 75.2875 117.214 76.0267 117.793"
        stroke="#242938"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M74.6172 95.2855C77.0106 94.7644 79.0856 94.8488 81.5887 94.8488C84.0077 94.8488 85.779 95.5277 87.6783 97.1021C89.5301 98.6361 90.6682 101.073 91.0744 103.381C91.3306 104.831 92.0333 108.651 90.7634 109.624C89.5008 110.593 88.725 109.216 88.015 107.304"
        stroke="#242938"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M76.8203 106.114C77.4644 106.848 77.8121 108.048 77.7681 108.899C77.7132 109.92 76.8203 112.36 77.501 113.215C79.4772 115.692 81.3875 109.909 81.3948 108.437C81.4021 106.965 81.4168 105.82 81.135 105.031"
        stroke="#242938"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M80.1484 112.417C80.3204 113.209 80.529 114.277 81.6306 114.296C82.615 114.31 83.3177 112.886 83.6141 112.145C84.4997 109.928 84.4997 107.998 84.2655 105.598C84.1447 104.365 83.669 103.132 83.3433 102.086"
        stroke="#242938"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M85.3172 99.8047C88.0985 103.339 89.1414 109.456 86.4553 113.736C85.7307 114.892 83.2678 115.523 83.6155 112.139"
        stroke="#242938"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M50.8843 114.586C48.3336 115.647 45.6877 117.023 43.0015 117.687C41.3766 118.087 39.7627 118.289 38.1049 118.406C36.5679 118.516 34.5661 119.082 33.0547 118.615"
        stroke="#242938"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M58.9297 91.5352C58.9297 91.6379 58.9297 91.7407 58.9297 91.8434"
        stroke="#242938"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M69.5703 38.7381C69.7716 39.0023 70.2327 38.9546 70.3827 38.5802C70.8365 37.4463 71.1696 36.2536 71.4001 35.0352C70.7999 35.1453 70.1961 35.2296 69.574 35.2774C69.5813 36.2829 69.5776 37.4646 69.5703 38.7381Z"
        fill="#242938"
      />
      <path
        d="M69.9249 29.9382C69.9762 29.1712 70.0969 28.4116 70.1591 27.6482C70.7117 27.4868 71.2936 27.3583 71.8755 27.2923C71.7511 25.516 71.4693 23.7435 70.6751 22.1361C69.8371 20.4406 68.8051 18.6387 66.7228 18.3304C66.7154 18.3047 66.7081 18.2827 66.7008 18.257C66.0165 15.2624 61.753 14.5761 59.2315 15.2918C56.1465 16.1652 53.6543 18.7818 50.357 18.9396C49.9691 18.958 49.7312 19.4424 50.0276 19.7323C52.0185 21.681 54.5509 21.4718 56.9589 21.27C58.5289 21.1379 60.5124 20.147 62.0275 19.6883C63.3266 19.2919 64.2964 19.6296 65.2845 20.6021C64.7429 22.3673 64.7685 23.8022 65.5553 25.5784C66.3495 27.373 68.0585 28.518 69.0613 30.1731C69.3101 30.5842 69.892 30.3896 69.9249 29.9382Z"
        fill="#242938"
      />
      <path
        d="M77.449 107.312C77.0684 108.028 76.4866 108.175 75.7656 108.314"
        stroke="#242938"
        strokeWidth="4"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
